module.exports = __webpack_public_path__ + "static/the-meritocracy-trap-4311771c3c0a842d9839039208d77e77.jpg";